import { CalendarCheck, Clock, Shield, Tag } from "lucide-react";
import { cn } from "@/lib/utils";

const BADGES = [
  { icon: Shield, label: "Secure booking" },
  { icon: CalendarCheck, label: "Instant confirmation" },
  { icon: Clock, label: "48-hour grace period" },
  { icon: Tag, label: "No platform fees" },
] as const;

/**
 * The four booking-page trust pills.
 *
 * Always two by two. A wrapping row left one pill orphaned on a second line
 * at most widths, and four across only fits on very wide columns, so the grid
 * is fixed: on phones two equal columns (text may wrap), from small screens up
 * two content-sized columns packed to the left so the pills stay compact and
 * their edges line up.
 */
export function TrustBadges({ className }: { className?: string }) {
  return (
    <ul
      className={cn(
        "grid grid-cols-2 gap-2.5 font-sans sm:grid-cols-[auto_auto] sm:justify-start sm:gap-3",
        className,
      )}
      aria-label="Why book direct"
      data-testid="trust-badges"
    >
      {BADGES.map(({ icon: Icon, label }) => (
        <li
          key={label}
          className="flex min-h-[42px] items-center justify-center gap-2 rounded-full border border-sand-deep bg-shell px-3.5 py-2 text-center text-[12.5px] leading-tight text-ink-soft sm:whitespace-nowrap sm:text-luxury-sm"
        >
          <Icon className="h-4 w-4 shrink-0 text-ink" aria-hidden="true" />
          <span>{label}</span>
        </li>
      ))}
    </ul>
  );
}
